import { FC } from 'react';
import type { SelectProps } from 'antd';
import { Select } from 'antd';
import MarkIcon from 'assets/icons/mark-icon.svg';
import dayjs from 'dayjs';
import localeData from 'dayjs/plugin/localeData';
import { capitalizeFirstLetter } from 'shared/lib';
import styled from 'styled-components';

import { IMonthSelectProps } from '../models/types';

import styles from './styles.module.scss';

dayjs.extend(localeData);

const StyledSelect = styled(Select)<SelectProps<number>>`
  .ant-select-selection-item {
    font-family: Inter;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0.2px;
  }
  .ant-select-selector:hover {
    background-color: var(--black-dark-8);
  }
`;

export const MonthSelect: FC<IMonthSelectProps> = ({
  value,
  year,
  onChange,
}) => {
  const months = Array.from({ length: 12 }, (_, i) => {
    const current = dayjs().year(year).month(i);
    return {
      value: i,
      label: capitalizeFirstLetter(current.localeData().months(current)),
      displayLabel: `${capitalizeFirstLetter(current.localeData().months(current))} ${year}`,
    };
  });

  return (
    <StyledSelect
      className={styles.select}
      value={value}
      suffixIcon={null}
      optionLabelProp="displayLabel"
      listHeight={220}
      onChange={(newMonth: number) => {
        const now = dayjs().year(year).month(newMonth);
        onChange(now);
      }}
    >
      {months.map((option) => (
        <Select.Option
          key={option.value}
          value={option.value}
          label={option.displayLabel}
          displayLabel={option.displayLabel}
        >
          <div className={styles.select__option}>
            {option.label}
            {option.value === value && (
              <img
                src={MarkIcon}
                alt="Галочка"
                className={styles.select__mark}
              />
            )}
          </div>
        </Select.Option>
      ))}
    </StyledSelect>
  );
};
